import React, { Fragment } from 'react';
import type { Nullable } from 'corgi-types';

import Separator from '../Separator';
import AdditionalInfoSection from './AdditionalInfoSection';
import EditAdditionalInfoButton from './EditAdditionalInfoButton';

export interface AdditionalInfoProps {
  partNumbers: string[];
  resources: string[];
  isDisabled: boolean;
  vendorOrderId: Nullable<string>;
  handleEdit?: () => void;
}

const AdditionalInfo = ({
  partNumbers,
  resources,
  isDisabled,
  handleEdit,
  vendorOrderId,
}: AdditionalInfoProps) =>
  !!partNumbers.length || !!resources.length || !!vendorOrderId?.length ? (
    <Fragment>
      <Separator />
      {!!handleEdit ? (
        <EditAdditionalInfoButton
          partNumbers={partNumbers}
          resources={resources}
          vendorOrderId={vendorOrderId}
          isDisabled={isDisabled}
          onClick={handleEdit}
        />
      ) : (
        <AdditionalInfoSection
          partNumbers={partNumbers}
          resources={resources}
          vendorOrderId={vendorOrderId}
        />
      )}
    </Fragment>
  ) : null;

export default AdditionalInfo;
